(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["im-mt-buy-link"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__imMtBuyLink) return;
    window.__imMtBuyLink = true;
    function target() {
      return document.querySelector('.product__info-container variant-radios, .product__info-container variant-selects') ||
        document.querySelector('.product__info-container');
    }
    function go(el) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - 110;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('[data-im-mt-buy], [data-im-mt-variant]') : null;
      if (!link) return;
      var box = target();
      if (!box) return;
      var value = link.getAttribute('data-im-mt-variant');
      if (value) {
        var radio = null;
        document.querySelectorAll('.product__info-container variant-radios input[type="radio"]').forEach(function (r) {
          if (!radio && r.value === value) radio = r;
        });
        if (!radio) return;
        if (!radio.checked) radio.click();
      }
      e.preventDefault();
      go(box);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["im-product-lightbox"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('im-product-lightbox')) {
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    class ImProductLightbox extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.ready = true;
        this.life = new AbortController();
        const on = (target, type, handler, options) => target?.addEventListener(type, handler, { signal: this.life.signal, ...options });
        this.stage = this.querySelector('[data-lb-stage]');
        this.track = this.querySelector('[data-lb-track]');
        this.fitBox = this.querySelector('[data-lb-fit]');
        this.bg = this.querySelector('[data-lb-bg]');
        this.hint = this.querySelector('[data-lb-hint]');
        this.live = this.querySelector('[data-lb-live]');
        this.counter = this.querySelector('[data-lb-current]');
        this.totalLabel = this.querySelector('[data-lb-total]');
        this.zoomButton = this.querySelector('[data-lb-zoom]');
        this.prevButton = this.querySelector('[data-lb-prev]');
        this.nextButton = this.querySelector('[data-lb-next]');
        this.thumbList = this.querySelector('[data-lb-thumbs]');
        this.ui = [...this.querySelectorAll('[data-lb-ui]')];
        this.slides = [...this.querySelectorAll('[data-lb-slide]')];
        this.thumbs = new Map([...this.querySelectorAll('[data-lb-thumb]')].map((thumb) => [thumb.dataset.mediaId, thumb]));
        this.sizes = new Map();
        this.pointers = new Map();
        this.items = [];
        this.index = -1;
        this.current = null;
        this.scale = 1;
        this.tx = 0;
        this.ty = 0;
        this.dragX = 0;
        this.dragY = 0;
        this.dragScale = 1;
        this.fine = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

        on(this.querySelector('[data-lb-close]'), 'click', () => this.hide());
        on(this.prevButton, 'click', () => this.go(this.index - 1));
        on(this.nextButton, 'click', () => this.go(this.index + 1));
        on(this.zoomButton, 'click', () => this.zoomTo(this.scale > 1.01 ? 1 : this.tapScale()));
        on(this.thumbList, 'click', (event) => {
          const thumb = event.target.closest('[data-lb-thumb]');
          if (thumb) this.go(this.items.findIndex((slide) => slide.dataset.mediaId === thumb.dataset.mediaId));
        });
        // Esc：用自己嘅 hide() 行埋動畫同 history；瀏覽器硬熄 dialog（例如連撳兩下 Esc）都照樣收尾
        on(this.dialog, 'cancel', (event) => {
          event.preventDefault();
          this.hide();
        });
        on(this.dialog, 'close', () => {
          if (this.isOpen) this.finish();
        });
        on(this.dialog, 'keydown', (event) => this.onKey(event));
        // Safari：trackpad 兩指撥係 gesture*（唔係 Ctrl + 滾輪）；手指 pinch 已經由 pointer 處理，唔好重複
        on(this.dialog, 'gesturestart', (event) => {
          event.preventDefault();
          this.gestureScale = this.scale;
        });
        on(this.dialog, 'gesturechange', (event) => {
          event.preventDefault();
          if (!this.isOpen || this.closing || this.pointers.size || !this.isImage() || !Number.isFinite(event.scale)) return;
          const point = Number.isFinite(event.clientX) ? this.point(event) : { x: this.cx, y: this.cy };
          this.pointerType = 'mouse';
          this.zoomTo((this.gestureScale || 1) * event.scale, point.x, point.y, this.fine.matches ? 'follow' : false);
        });
        on(this.stage, 'pointerdown', (event) => this.onDown(event));
        on(this.stage, 'pointermove', (event) => this.onMove(event));
        on(this.stage, 'pointerup', (event) => this.onUp(event));
        on(this.stage, 'pointercancel', (event) => this.onUp(event, true));
        on(this.stage, 'wheel', (event) => this.onWheel(event), { passive: false });
        on(this.stage, 'dragstart', (event) => event.preventDefault());
        on(window, 'popstate', () => this.onPop());
        on(window, 'resize', () => this.relayout());
      }

      disconnectedCallback() {
        if (this.isOpen) document.documentElement.classList.remove('im-lb-open');
        this.life?.abort();
        this.stopGlide();
        clearTimeout(this.hintTimer);
        this.ready = false;
      }

      get isOpen() {
        return this.hasAttribute('open');
      }

      // modal-opener（global.js）同 im-product-video 都係 show(button)；button.dataset.mediaId = 開邊張
      show(opener, options = {}) {
        if (!this.ready || this.closing) return;
        const mediaId = String(options.mediaId || opener?.dataset?.mediaId || '');
        if (this.isOpen) {
          const index = this.items.findIndex((slide) => slide.dataset.mediaId === mediaId);
          if (index >= 0) this.go(index);
          return;
        }
        this.opener = opener instanceof HTMLElement ? opener : document.activeElement;
        this.collect();
        const index = Math.max(0, this.items.findIndex((slide) => slide.dataset.mediaId === mediaId));
        window.pauseAllMedia?.();
        this.setAttribute('open', '');
        document.documentElement.classList.add('im-lb-open');
        this.dialog.classList.toggle('is-single', this.items.length < 2);
        try {
          this.dialog.showModal();
        } catch (error) {
          this.dialog.setAttribute('open', '');
        }
        this.dialog.focus({ preventScroll: true });
        this.measure();
        this.index = -1;
        this.go(index, { instant: true, time: options.time });
        this.animateIn(this.sourceFor(this.current.dataset.mediaId));
        this.pushHistory();
        if (this.isImage()) this.showHint();
      }

      hide(options = {}) {
        if (!this.isOpen || this.closing) return;
        this.closing = true;
        this.stopGlide();
        this.hideHint();
        document.documentElement.classList.remove('im-lb-open');
        if (this.pushed && !options.fromHistory) {
          this.pushed = false;
          this.expectPop = true;
          this.pushAfterPop = false;
          try {
            history.back();
          } catch (error) {
            this.expectPop = false;
          }
        }
        this.items.forEach((slide) => this.pause(slide));
        if (this.current) this.syncGallery(this.current.dataset.mediaId);
        const animations = this.animateOut(options);
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          this.finish();
        };
        if (!animations.length) {
          finish();
          return;
        }
        Promise.all(animations.map((animation) => animation.finished.catch(() => {}))).then(finish);
        setTimeout(finish, 700);
      }

      finish() {
        if (!this.isOpen) return;
        this.closing = false;
        this.removeAttribute('open');
        document.documentElement.classList.remove('im-lb-open');
        [this.bg, ...this.ui, ...this.slides.map((slide) => slide.querySelector('[data-lb-frame]'))].forEach((element) => {
          element?.getAnimations?.().forEach((animation) => animation.cancel());
        });
        try {
          if (this.dialog.open) this.dialog.close();
        } catch (error) {
          /* 冇 <dialog> 支援就行下面 removeAttribute */
        }
        this.dialog.removeAttribute('open');
        this.pointers.clear();
        this.gesture = null;
        this.pinch = null;
        this.lastTap = null;
        this.scale = 1;
        this.tx = 0;
        this.ty = 0;
        this.dragX = 0;
        this.dragY = 0;
        this.dragScale = 1;
        this.bg.style.opacity = '';
        this.ui.forEach((element) => {
          element.style.opacity = '';
        });
        this.dialog.classList.remove('is-zoomed', 'is-fading');
        this.track.classList.remove('is-animating');
        this.slides.forEach((slide) => {
          const frame = slide.querySelector('[data-lb-frame]');
          frame.classList.remove('is-animating', 'is-following');
          frame.style.transform = '';
          this.pause(slide);
        });
        const opener = this.opener;
        this.opener = null;
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      }

      // 跟返頁面相簿嘅次序同可見嘅相：已揀款式張相喺頭、收埋嘅款式相（display:none）唔要、360°（data-media-id=…-spin）冇對應 slide
      collect() {
        const prefix = `${this.dataset.section}-`;
        const gallery = document.getElementById(`Slider-${this.dataset.section}`);
        const byId = new Map(this.slides.map((slide) => [slide.dataset.mediaId, slide]));
        let items = [];
        for (const item of gallery ? gallery.children : []) {
          const id = item.dataset?.mediaId || '';
          if (!id.startsWith(prefix) || item.hidden || !item.getClientRects().length) continue;
          const slide = byId.get(id.slice(prefix.length));
          if (slide && !items.includes(slide)) items.push(slide);
        }
        if (!items.length) items = this.slides.slice();
        this.items = items;
        const total = String(items.length);
        this.slides.forEach((slide) => {
          const hidden = !items.includes(slide);
          slide.hidden = hidden;
          const thumb = this.thumbs.get(slide.dataset.mediaId);
          if (thumb) thumb.parentElement.hidden = hidden;
        });
        items.forEach((slide, index) => {
          const position = String(index + 1);
          this.track.append(slide);
          slide.setAttribute('aria-label', (this.dataset.labelSlide || '').replace('[i]', position).replace('[n]', total));
          const thumb = this.thumbs.get(slide.dataset.mediaId);
          if (!thumb) return;
          this.thumbList.append(thumb.parentElement);
          thumb.setAttribute('aria-label', (this.dataset.labelThumb || '').replace('[i]', position));
        });
        this.totalLabel.textContent = total;
      }

      measure() {
        const stage = this.stage.getBoundingClientRect();
        const fit = this.fitBox.getBoundingClientRect();
        this.ox = stage.left;
        this.oy = stage.top;
        this.W = stage.width || window.innerWidth;
        this.H = stage.height || window.innerHeight;
        this.cx = fit.left - stage.left + fit.width / 2;
        this.cy = fit.top - stage.top + fit.height / 2;
        this.gap = parseFloat(getComputedStyle(this.dialog).getPropertyValue('--lb-gap')) || 0;
        this.items.forEach((slide) => {
          const ratio = (Number(slide.dataset.w) || 1) / (Number(slide.dataset.h) || 1);
          const fw = Math.max(1, Math.min(fit.width, fit.height * ratio));
          const fh = fw / ratio;
          this.sizes.set(slide, { fw, fh });
          const frame = slide.querySelector('[data-lb-frame]');
          frame.style.width = `${fw}px`;
          frame.style.height = `${fh}px`;
        });
      }

      relayout() {
        if (!this.isOpen || this.closing) return;
        this.measure();
        this.clampPan();
        this.applyFrame(false);
        this.placeTrack(false);
      }

      go(target, options = {}) {
        if (!this.items.length) return;
        const index = clamp(target, 0, this.items.length - 1);
        const previous = this.current;
        const changed = index !== this.index;
        this.index = index;
        this.current = this.items[index];
        this.dragX = 0;
        this.placeTrack(!options.instant);
        if (changed) {
          if (previous && previous !== this.current) this.leave(previous, options.instant);
          this.scale = 1;
          this.tx = 0;
          this.ty = 0;
          this.dragY = 0;
          this.dragScale = 1;
          this.applyFrame(false);
          this.afterZoom();
          [index, index + 1, index - 1].forEach((position) => {
            if (this.items[position]) this.load(this.items[position]);
          });
          this.playCurrent(options.time);
          if (!options.instant) this.hideHint();
        }
        this.updateUi(options.instant);
      }

      leave(slide, instant) {
        this.pause(slide);
        const frame = slide.querySelector('[data-lb-frame]');
        const reset = () => {
          if (slide === this.current) return;
          frame.classList.remove('is-animating', 'is-following');
          frame.style.transform = '';
        };
        if (instant || this.reduce.matches) reset();
        else setTimeout(reset, 400);
      }

      updateUi(instant) {
        const media = !this.isImage();
        this.counter.textContent = String(this.index + 1);
        this.prevButton.disabled = this.index <= 0;
        this.nextButton.disabled = this.index >= this.items.length - 1;
        this.zoomButton.disabled = media;
        this.dialog.classList.toggle('is-media', media);
        this.items.forEach((slide, position) => {
          const active = position === this.index;
          slide.classList.toggle('is-current', active);
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.thumbs.forEach((thumb, id) => thumb.setAttribute('aria-current', String(id === this.current.dataset.mediaId)));
        this.live.textContent = this.current.getAttribute('aria-label') || '';
        const thumb = this.thumbs.get(this.current.dataset.mediaId);
        const list = this.thumbList;
        if (thumb && list.scrollWidth > list.clientWidth) {
          const left = thumb.offsetLeft - (list.clientWidth - thumb.offsetWidth) / 2;
          list.scrollTo({ left, behavior: instant || this.reduce.matches ? 'auto' : 'smooth' });
        }
      }

      // 未載好高清之前，用相簿已經載好嗰張（冇就用縮圖）墊底，唔會見到白色一片
      load(slide) {
        const frame = slide.querySelector('[data-lb-frame]');
        if (frame && !frame.style.backgroundImage) {
          const placeholder = this.placeholderFor(slide);
          if (placeholder) frame.style.backgroundImage = `url("${placeholder.replace(/"/g, '%22')}")`;
        }
        const image = slide.querySelector('[data-lb-img]');
        if (!image || image.dataset.state) return;
        image.dataset.state = 'loading';
        slide.classList.add('is-loading');
        image.addEventListener('load', () => {
          image.dataset.state = 'loaded';
          slide.classList.remove('is-loading');
          if (frame) frame.style.backgroundImage = 'none';
        }, { once: true });
        image.addEventListener('error', () => {
          if (image.dataset.state !== 'loading') return;
          image.dataset.state = 'error';
          slide.classList.remove('is-loading');
        }, { once: true });
        const size = this.sizes.get(slide);
        image.sizes = `${Math.ceil(size ? size.fw : this.W)}px`;
        image.srcset = image.dataset.srcset || '';
        image.src = image.dataset.src || '';
      }

      placeholderFor(slide) {
        const source = this.sourceFor(slide.dataset.mediaId);
        if (source?.tagName === 'IMG' && source.complete && source.naturalWidth > 0 && source.currentSrc) return source.currentSrc;
        return slide.dataset.placeholder || '';
      }

      sourceFor(id) {
        const section = this.dataset.section;
        const item = document.getElementById(`Slider-${section}`)?.querySelector(`[data-media-id="${section}-${id}"]`);
        return item?.querySelector('.product__media img, im-product-video video, .deferred-media__poster img') || null;
      }

      // 片：入到嗰張先插 <video>，靜音自動播（同頁面嗰條一樣），可以自己開聲；由頁面放大掣入嚟就由同一秒繼續
      playCurrent(time) {
        const slide = this.current;
        if (!slide || this.isImage()) return;
        if (slide.dataset.type === 'model') {
          slide.querySelector('product-model')?.loadContent?.();
          return;
        }
        const frame = slide.querySelector('[data-lb-frame]');
        if (!frame.querySelector('video, iframe')) {
          const node = slide.querySelector('template[data-lb-media]')?.content.firstElementChild?.cloneNode(true);
          if (node) frame.append(node);
        }
        const video = frame.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.playsInline = true;
        if (Number.isFinite(time) && time > 0) {
          // 未有 metadata 時設 currentTime = 起播位置；有啲瀏覽器唔認，metadata 到咗再 seek 一次
          const seek = () => {
            if (slide !== this.current || Math.abs(video.currentTime - time) < 0.5) return;
            try {
              video.currentTime = time;
            } catch (error) {
              /* seek 唔到就由頭播 */
            }
          };
          seek();
          if (video.readyState < 1) video.addEventListener('loadedmetadata', seek, { once: true });
        }
        video.play().catch(() => {});
      }

      pause(slide) {
        slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelectorAll('iframe').forEach((frame) => {
          const message = frame.classList.contains('js-vimeo') ? '{"method":"pause"}' : '{"event":"command","func":"pauseVideo","args":""}';
          try {
            frame.contentWindow?.postMessage(message, '*');
          } catch (error) {
            /* iframe 未 load */
          }
        });
        slide.querySelector('product-model')?.modelViewerUI?.pause?.();
      }

      // 熄嗰陣將頁面相簿（手機橫掃）同下面縮圖帶去最後睇緊嗰張，唔會郁到成頁上落
      syncGallery(id) {
        const section = this.dataset.section;
        const gallery = document.getElementById(`Slider-${section}`);
        const item = gallery?.querySelector(`[data-media-id="${section}-${id}"]`);
        if (!item) return;
        if (gallery.scrollWidth > gallery.clientWidth + 1) {
          const behavior = gallery.style.scrollBehavior;
          const padding = parseFloat(getComputedStyle(gallery).scrollPaddingLeft) || 0;
          gallery.style.scrollBehavior = 'auto';
          gallery.scrollLeft += item.getBoundingClientRect().left - gallery.getBoundingClientRect().left - padding;
          gallery.style.scrollBehavior = behavior;
        }
        document.querySelectorAll(`[data-thumbnail-target^="${section}-"]`).forEach((thumb) => {
          const active = thumb.dataset.thumbnailTarget === `${section}-${id}`;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', String(active));
        });
      }

      isImage() {
        return this.current?.dataset.type === 'image';
      }

      frame() {
        return this.current?.querySelector('[data-lb-frame]') || null;
      }

      size() {
        return this.sizes.get(this.current) || { fw: this.W || 1, fh: this.H || 1 };
      }

      maxScale() {
        const { fw } = this.size();
        const natural = Number(this.current?.dataset.w) || fw;
        return clamp((natural / fw) * 1.5, 2.5, 4);
      }

      // 撳兩下放大到填滿成個畫面（最少 2 倍），打橫相喺手機就即刻睇到成個高度
      tapScale() {
        const { fw, fh } = this.size();
        return clamp(Math.max(2, this.W / fw, this.H / fh), 1, this.maxScale());
      }

      // 相中心固定喺 (cx, cy)；t = 平移。張相可以蓋過上下 bar，但唔會拉到露出空位
      bounds(scale = this.scale) {
        const { fw, fh } = this.size();
        const width = fw * scale;
        const height = fh * scale;
        const x1 = this.W - this.cx - width / 2;
        const x2 = width / 2 - this.cx;
        const y1 = this.H - this.cy - height / 2;
        const y2 = height / 2 - this.cy;
        return { minX: Math.min(x1, x2), maxX: Math.max(x1, x2), minY: Math.min(y1, y2), maxY: Math.max(y1, y2) };
      }

      clampPan() {
        const bounds = this.bounds();
        this.tx = clamp(this.tx, bounds.minX, bounds.maxX);
        this.ty = clamp(this.ty, bounds.minY, bounds.maxY);
      }

      rubber(value, min, max) {
        if (value < min) return min - (min - value) * 0.35;
        if (value > max) return max + (value - max) * 0.35;
        return value;
      }

      applyFrame(mode) {
        const frame = this.frame();
        if (!frame) return;
        const motion = !this.reduce.matches;
        frame.classList.toggle('is-animating', mode === 'animate' && motion);
        frame.classList.toggle('is-following', mode === 'follow' && motion);
        frame.style.transform = `translate3d(${this.tx}px, ${this.ty + this.dragY}px, 0) scale(${this.scale * this.dragScale})`;
      }

      placeTrack(animate) {
        this.track.classList.toggle('is-animating', Boolean(animate) && !this.reduce.matches);
        this.track.style.transform = `translate3d(${-this.index * (this.W + this.gap) + this.dragX}px, 0, 0)`;
      }

      // (x, y) = stage 座標。滑鼠：張相跟住滑鼠位置走；手指 / 鍵盤：放大嗰點保持喺原位
      zoomTo(scale, x = this.cx, y = this.cy, mode = 'animate') {
        if (!this.isImage()) return;
        const next = scale <= 1.01 ? 1 : Math.min(scale, this.maxScale());
        if (next === 1) {
          this.tx = 0;
          this.ty = 0;
        } else if (this.pointerType === 'mouse' && this.fine.matches) {
          this.scale = next;
          this.follow(x, y, mode);
          this.afterZoom();
          return;
        } else {
          this.tx = x - this.cx - ((x - this.cx - this.tx) * next) / this.scale;
          this.ty = y - this.cy - ((y - this.cy - this.ty) * next) / this.scale;
        }
        this.scale = next;
        this.clampPan();
        this.applyFrame(mode);
        this.afterZoom();
      }

      follow(x, y, mode = 'follow') {
        const { fw, fh } = this.size();
        const bounds = this.bounds();
        const marginX = this.W * 0.1;
        const marginY = this.H * 0.1;
        const rx = clamp((x - marginX) / Math.max(1, this.W - marginX * 2), 0, 1);
        const ry = clamp((y - marginY) / Math.max(1, this.H - marginY * 2), 0, 1);
        this.tx = fw * this.scale > this.W ? bounds.maxX + (bounds.minX - bounds.maxX) * rx : clamp(0, bounds.minX, bounds.maxX);
        this.ty = fh * this.scale > this.H ? bounds.maxY + (bounds.minY - bounds.maxY) * ry : clamp(0, bounds.minY, bounds.maxY);
        this.applyFrame(mode);
      }

      afterZoom() {
        const zoomed = this.scale > 1.01;
        this.dialog.classList.toggle('is-zoomed', zoomed);
        const label = zoomed ? this.zoomButton.dataset.labelOut : this.zoomButton.dataset.labelIn;
        if (label) this.zoomButton.setAttribute('aria-label', label);
        if (!zoomed || !this.isImage()) return;
        this.hideHint();
        // 放大咗先要大圖：sizes 跟放大後闊度，瀏覽器自己由 srcset 揀
        const image = this.current.querySelector('[data-lb-img]');
        const width = Math.ceil(this.size().fw * Math.min(this.scale, this.maxScale()));
        if (image?.getAttribute('srcset') && width > (parseInt(image.sizes, 10) || 0) * 1.15) image.sizes = `${width}px`;
      }

      point(event) {
        return { x: event.clientX - this.ox, y: event.clientY - this.oy };
      }

      onDown(event) {
        if (!this.isOpen || this.closing) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        const target = event.target;
        if (target.closest?.('iframe, product-model')) return;
        // 片底嘅播放列留返俾瀏覽器（拉進度、開聲）
        const video = target.closest?.('video');
        if (video && event.clientY > video.getBoundingClientRect().bottom - 56) return;
        this.stopGlide();
        this.frame()?.getAnimations?.().forEach((animation) => animation.finish());
        const point = this.point(event);
        const now = performance.now();
        this.pointers.set(event.pointerId, point);
        this.pointerType = event.pointerType;
        if (this.pointers.size === 1) {
          this.gesture = { id: event.pointerId, kind: null, type: event.pointerType, x: point.x, y: point.y, tx: this.tx, ty: this.ty, time: now, samples: [{ x: point.x, y: point.y, t: now }] };
        } else if (this.pointers.size === 2 && event.pointerType !== 'mouse') {
          this.startPinch();
        }
      }

      onMove(event) {
        if (!this.isOpen || this.closing) return;
        const point = this.point(event);
        if (event.pointerType === 'mouse') {
          this.pointerType = 'mouse';
          if (this.scale > 1.01 && this.isImage() && this.fine.matches) this.follow(point.x, point.y);
        }
        const stored = this.pointers.get(event.pointerId);
        if (!stored) return;
        stored.x = point.x;
        stored.y = point.y;
        if (this.pinch) {
          this.movePinch();
          return;
        }
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        const now = performance.now();
        gesture.samples.push({ x: point.x, y: point.y, t: now });
        while (gesture.samples.length > 2 && now - gesture.samples[0].t > 120) gesture.samples.shift();
        const dx = point.x - gesture.x;
        const dy = point.y - gesture.y;
        if (!gesture.kind) {
          if (Math.hypot(dx, dy) < (gesture.type === 'mouse' ? 5 : 8)) return;
          if (this.scale > 1.01) gesture.kind = gesture.type === 'mouse' ? 'none' : 'pan';
          else if (Math.abs(dx) >= Math.abs(dy)) gesture.kind = this.items.length > 1 ? 'swipe' : 'none';
          else gesture.kind = gesture.type === 'mouse' ? 'none' : 'close';
          if (gesture.kind === 'none') return;
          try {
            this.stage.setPointerCapture(event.pointerId);
          } catch (error) {
            /* pointer 已經走咗 */
          }
          this.hideHint();
        }
        if (gesture.kind === 'swipe') {
          const edge = (this.index === 0 && dx > 0) || (this.index === this.items.length - 1 && dx < 0);
          this.dragX = edge ? dx * 0.3 : dx;
          this.placeTrack(false);
        } else if (gesture.kind === 'close') {
          const progress = Math.min(1, Math.abs(dy) / (this.H * 0.5));
          this.dragY = dy;
          this.dragScale = 1 - progress * 0.25;
          this.applyFrame(false);
          this.fade(1 - progress);
        } else if (gesture.kind === 'pan') {
          const bounds = this.bounds();
          this.tx = this.rubber(gesture.tx + dx, bounds.minX, bounds.maxX);
          this.ty = this.rubber(gesture.ty + dy, bounds.minY, bounds.maxY);
          this.applyFrame(false);
        }
      }

      onUp(event, cancelled = false) {
        if (!this.pointers.has(event.pointerId)) return;
        this.pointers.delete(event.pointerId);
        if (this.pinch) {
          this.pinch = null;
          this.settle();
          if (this.pointers.size === 1) {
            // 兩指放咗一隻：放大咗就接住用剩低嗰隻拖
            const [[id, point]] = this.pointers;
            const now = performance.now();
            const kind = this.scale > 1.01 && this.isImage() ? 'pan' : 'none';
            this.gesture = { id, kind, type: 'touch', x: point.x, y: point.y, tx: this.tx, ty: this.ty, time: now, samples: [{ x: point.x, y: point.y, t: now }] };
          }
          return;
        }
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        this.gesture = null;
        const point = this.point(event);
        if (cancelled) {
          this.snapBack(gesture);
          return;
        }
        if (!gesture.kind) {
          this.tap(gesture, event, point);
          return;
        }
        const velocity = this.velocity(gesture.samples, point);
        if (gesture.kind === 'swipe') {
          const dx = point.x - gesture.x;
          const threshold = Math.min(this.W * 0.2, 140);
          let index = this.index;
          if (dx < -threshold || (velocity.x < -0.35 && dx < -12)) index += 1;
          else if (dx > threshold || (velocity.x > 0.35 && dx > 12)) index -= 1;
          this.dragX = 0;
          this.go(index);
        } else if (gesture.kind === 'close') {
          if (Math.abs(this.dragY) > Math.min(160, this.H * 0.18) || Math.abs(velocity.y) > 0.6) this.hide({ swipe: true });
          else this.snapBack(gesture);
        } else if (gesture.kind === 'pan') {
          this.glide(velocity.x, velocity.y);
        }
      }

      snapBack(gesture) {
        if (gesture.kind === 'swipe') {
          this.dragX = 0;
          this.placeTrack(true);
        } else if (gesture.kind === 'close') {
          this.dragY = 0;
          this.dragScale = 1;
          this.applyFrame('animate');
          this.fade(1, true);
        } else if (gesture.kind === 'pan') {
          this.clampPan();
          this.applyFrame('animate');
        }
      }

      velocity(samples, point) {
        const now = performance.now();
        const first = samples.find((sample) => now - sample.t <= 120) || samples[samples.length - 1];
        const elapsed = first ? now - first.t : 0;
        if (!first || elapsed < 8) return { x: 0, y: 0 };
        return { x: (point.x - first.x) / elapsed, y: (point.y - first.y) / elapsed };
      }

      tap(gesture, event, point) {
        if (performance.now() - gesture.time > 450) return;
        const image = this.isImage();
        const onFrame = Boolean(this.current?.contains(event.target) && event.target.closest?.('[data-lb-frame]'));
        if (gesture.type === 'mouse') {
          if (this.scale > 1.01) this.zoomTo(1, point.x, point.y);
          else if (onFrame && image) this.zoomTo(this.tapScale(), point.x, point.y);
          else if (!onFrame) this.hide();
          return;
        }
        const last = this.lastTap;
        const now = performance.now();
        if (last && now - last.t < 320 && Math.hypot(point.x - last.x, point.y - last.y) < 40) {
          this.lastTap = null;
          if (image) this.zoomTo(this.scale > 1.01 ? 1 : this.tapScale(), point.x, point.y);
        } else {
          this.lastTap = { x: point.x, y: point.y, t: now };
        }
      }

      startPinch() {
        const gesture = this.gesture;
        if (gesture) this.snapBack(gesture);
        this.gesture = null;
        this.lastTap = null;
        const [a, b] = [...this.pointers.values()];
        this.pinch = {
          distance: Math.hypot(a.x - b.x, a.y - b.y) || 1,
          x: (a.x + b.x) / 2,
          y: (a.y + b.y) / 2,
          scale: this.scale,
          tx: this.tx,
          ty: this.ty,
        };
        this.lastMid = { x: this.pinch.x, y: this.pinch.y };
        this.frame()?.classList.remove('is-animating', 'is-following');
        this.hideHint();
      }

      movePinch() {
        const pinch = this.pinch;
        if (!pinch || !this.isImage() || this.pointers.size < 2) return;
        const [a, b] = [...this.pointers.values()];
        const x = (a.x + b.x) / 2;
        const y = (a.y + b.y) / 2;
        const max = this.maxScale();
        let scale = (pinch.scale * (Math.hypot(a.x - b.x, a.y - b.y) || 1)) / pinch.distance;
        if (scale < 1) scale = 1 - (1 - scale) * 0.45;
        if (scale > max) scale = max + (scale - max) * 0.3;
        scale = Math.max(scale, 0.5);
        // 兩指中間嗰點對住張相邊度，就一直對住嗰度
        const qx = (pinch.x - this.cx - pinch.tx) / pinch.scale;
        const qy = (pinch.y - this.cy - pinch.ty) / pinch.scale;
        this.scale = scale;
        this.tx = x - this.cx - qx * scale;
        this.ty = y - this.cy - qy * scale;
        this.lastMid = { x, y };
        this.applyFrame(false);
      }

      settle() {
        const max = this.maxScale();
        if (this.scale < 1.03) {
          this.scale = 1;
          this.tx = 0;
          this.ty = 0;
        } else if (this.scale > max) {
          const mid = this.lastMid || { x: this.cx, y: this.cy };
          this.tx = mid.x - this.cx - ((mid.x - this.cx - this.tx) * max) / this.scale;
          this.ty = mid.y - this.cy - ((mid.y - this.cy - this.ty) * max) / this.scale;
          this.scale = max;
        }
        this.clampPan();
        this.applyFrame('animate');
        this.afterZoom();
      }

      glide(vx, vy) {
        const bounds = this.bounds();
        const outside = this.tx < bounds.minX || this.tx > bounds.maxX || this.ty < bounds.minY || this.ty > bounds.maxY;
        if (outside || Math.hypot(vx, vy) < 0.05 || this.reduce.matches) {
          this.clampPan();
          this.applyFrame('animate');
          return;
        }
        let last = performance.now();
        const step = (now) => {
          const elapsed = Math.min(32, now - last);
          last = now;
          this.tx += vx * elapsed;
          this.ty += vy * elapsed;
          const decay = Math.pow(0.94, elapsed / 16);
          vx *= decay;
          vy *= decay;
          const limit = this.bounds();
          if (this.tx < limit.minX || this.tx > limit.maxX) vx = 0;
          if (this.ty < limit.minY || this.ty > limit.maxY) vy = 0;
          this.clampPan();
          this.applyFrame(false);
          this.raf = Math.hypot(vx, vy) > 0.02 ? requestAnimationFrame(step) : null;
        };
        this.raf = requestAnimationFrame(step);
      }

      stopGlide() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
      }

      // 滾輪 / trackpad：未放大 = 轉相（一下一張）；Ctrl + 滾輪、trackpad 兩指撥、放大咗之後 = 放大縮細
      onWheel(event) {
        if (!this.isOpen || this.closing) return;
        event.preventDefault();
        const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.H : 1;
        const dx = event.deltaX * unit;
        const dy = event.deltaY * unit;
        const now = performance.now();
        if (now - (this.wheelAt || 0) > 200) {
          this.wheelSum = 0;
          this.wheelLock = false;
        }
        this.wheelAt = now;
        if (this.wheelLock) return;
        if (this.isImage() && (event.ctrlKey || this.scale > 1.01)) {
          const factor = Math.exp(-clamp(dy, -100, 100) * (event.ctrlKey ? 0.01 : 0.0025));
          const point = this.point(event);
          const next = this.scale * factor;
          if (next <= 1.01 && this.scale > 1.01) this.wheelLock = true;
          this.pointerType = 'mouse';
          this.zoomTo(next, point.x, point.y, this.fine.matches ? 'follow' : false);
          return;
        }
        if (this.items.length < 2) return;
        this.wheelSum = (this.wheelSum || 0) + (Math.abs(dx) > Math.abs(dy) ? dx : dy);
        if (Math.abs(this.wheelSum) >= 50) {
          this.wheelLock = true;
          this.go(this.index + Math.sign(this.wheelSum));
        }
      }

      onKey(event) {
        if (!this.isOpen || this.closing || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target.closest?.('video, iframe, product-model, input, select, textarea')) return;
        const zoomed = this.scale > 1.01;
        const pan = (x, y) => {
          this.tx += x;
          this.ty += y;
          this.clampPan();
          this.applyFrame('animate');
        };
        switch (event.key) {
          case 'ArrowLeft':
            if (zoomed) pan(90, 0);
            else this.go(this.index - 1);
            break;
          case 'ArrowRight':
            if (zoomed) pan(-90, 0);
            else this.go(this.index + 1);
            break;
          case 'ArrowUp':
            if (!zoomed) return;
            pan(0, 90);
            break;
          case 'ArrowDown':
            if (!zoomed) return;
            pan(0, -90);
            break;
          case 'Home':
            this.go(0);
            break;
          case 'End':
            this.go(this.items.length - 1);
            break;
          case '+':
          case '=':
            this.zoomTo(Math.max(this.scale * 1.6, this.tapScale()));
            break;
          case '-':
            this.zoomTo(this.scale / 1.6);
            break;
          case '0':
            this.zoomTo(1);
            break;
          case 'Escape':
            this.hide();
            break;
          default:
            return;
        }
        event.preventDefault();
      }

      fade(opacity, animate = false) {
        this.dialog.classList.toggle('is-fading', animate);
        this.bg.style.opacity = opacity >= 1 ? '' : String(opacity);
        const ui = opacity >= 1 ? '' : String(Math.max(0, 1 - (1 - opacity) * 2.5));
        this.ui.forEach((element) => {
          element.style.opacity = ui;
        });
      }

      // 手機撳返回 = 熄 lightbox（唔會離開產品頁）
      pushHistory() {
        if (window.Shopify?.designMode) return;
        if (this.expectPop) {
          this.pushAfterPop = true;
          return;
        }
        try {
          history.pushState(Object.assign({}, history.state, { imLightbox: true }), '');
          this.pushed = true;
        } catch (error) {
          this.pushed = false;
        }
      }

      onPop() {
        if (this.expectPop) {
          this.expectPop = false;
          if (this.pushAfterPop) {
            this.pushAfterPop = false;
            if (this.isOpen && !this.closing) this.pushHistory();
          }
          return;
        }
        if (this.isOpen && this.pushed) {
          this.pushed = false;
          this.hide({ fromHistory: true });
        }
      }

      showHint() {
        if (!this.hint) return;
        let seen = false;
        try {
          seen = sessionStorage.getItem('im-lb-hint') === '1';
          sessionStorage.setItem('im-lb-hint', '1');
        } catch (error) {
          /* private mode：照出 */
        }
        if (seen) return;
        this.hint.textContent = this.fine.matches ? this.hint.dataset.mouse : this.hint.dataset.touch;
        this.hint.hidden = false;
        requestAnimationFrame(() => this.hint.classList.add('is-visible'));
        clearTimeout(this.hintTimer);
        this.hintTimer = setTimeout(() => this.hideHint(), 3200);
      }

      hideHint() {
        clearTimeout(this.hintTimer);
        this.hint?.classList.remove('is-visible');
      }

      // 開：由相簿張相嘅位置放大入嚟（FLIP）；睇唔到原本張相就淡入
      animateIn(source) {
        if (!this.bg.animate) return;
        const reduce = this.reduce.matches;
        this.bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: reduce ? 120 : 260, easing: 'ease-out' });
        this.ui.forEach((element) => element.animate([{ opacity: 0 }, { opacity: 1 }], { duration: reduce ? 120 : 360, easing: 'ease-out' }));
        const frame = this.frame();
        if (!frame || reduce) return;
        const rect = source?.getBoundingClientRect();
        const visible = rect && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
        if (!visible) {
          frame.animate([{ opacity: 0, transform: 'translate3d(0, 0, 0) scale(0.94)' }, { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' }], { duration: 260, easing: 'cubic-bezier(0.2, 0.8, 0.25, 1)' });
          return;
        }
        const x = rect.left + rect.width / 2 - (this.ox + this.cx);
        const y = rect.top + rect.height / 2 - (this.oy + this.cy);
        frame.animate([{ transform: `translate3d(${x}px, ${y}px, 0) scale(${rect.width / this.size().fw})` }, { transform: 'translate3d(0, 0, 0) scale(1)' }], { duration: 340, easing: 'cubic-bezier(0.2, 0.8, 0.25, 1)' });
      }

      // 熄：縮返落相簿嗰張相度；向下掃就順住方向飛走；睇唔到就淡出
      animateOut(options) {
        const list = [];
        if (!this.bg.animate) return list;
        const reduce = this.reduce.matches;
        const fadeOut = (element, duration) => {
          list.push(element.animate([{ opacity: getComputedStyle(element).opacity }, { opacity: 0 }], { duration, easing: 'ease-out', fill: 'forwards' }));
        };
        fadeOut(this.bg, reduce ? 120 : 260);
        this.ui.forEach((element) => fadeOut(element, reduce ? 120 : 180));
        const frame = this.frame();
        if (!frame) return list;
        if (reduce) {
          fadeOut(frame, 120);
          return list;
        }
        const scale = this.scale * this.dragScale;
        const from = `translate3d(${this.tx}px, ${this.ty + this.dragY}px, 0) scale(${scale})`;
        const rect = this.sourceFor(this.current.dataset.mediaId)?.getBoundingClientRect();
        const visible = rect && rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
        let keyframes;
        if (visible) {
          const x = rect.left + rect.width / 2 - (this.ox + this.cx);
          const y = rect.top + rect.height / 2 - (this.oy + this.cy);
          keyframes = [{ transform: from }, { transform: `translate3d(${x}px, ${y}px, 0) scale(${rect.width / this.size().fw})` }];
        } else if (options.swipe) {
          const direction = this.dragY < 0 ? -1 : 1;
          keyframes = [
            { transform: from, opacity: 1 },
            { transform: `translate3d(${this.tx}px, ${this.ty + this.dragY + direction * this.H * 0.5}px, 0) scale(${scale})`, opacity: 0 },
          ];
        } else {
          keyframes = [
            { transform: from, opacity: 1 },
            { transform: `translate3d(${this.tx}px, ${this.ty + this.dragY}px, 0) scale(${scale * 0.94})`, opacity: 0 },
          ];
        }
        frame.classList.remove('is-animating', 'is-following');
        list.push(frame.animate(keyframes, { duration: visible ? 320 : 240, easing: 'cubic-bezier(0.3, 0.7, 0.2, 1)', fill: 'forwards' }));
        return list;
      }
    }

    customElements.define('im-product-lightbox', ImProductLightbox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["im-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('im-product-video')) {
    customElements.define('im-product-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.toggle = this.querySelector('.im-product-video__toggle');
        this.video.controls = false;
        this.video.muted = true;
        this.userPaused = false;
        this.visible = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const sync = () => {
          const playing = !this.video.paused && !this.video.ended;
          this.toggleAttribute('data-playing', playing);
          this.toggle.setAttribute('aria-pressed', String(playing));
        };
        this.video.addEventListener('play', sync, options);
        this.video.addEventListener('pause', sync, options);
        this.video.addEventListener('ended', sync, options);
        this.toggle.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.play();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.querySelector('.im-product-video__expand').addEventListener('click', (event) => {
          const modal = document.getElementById(this.dataset.modalId);
          if (!modal || typeof modal.show !== 'function') return;
          this.userPaused = true;
          this.video.pause();
          // 產品頁 lightbox（im-product-lightbox）自己插片同由同一秒播；舊 product-modal（featured-product）行下面
          if (modal.localName === 'im-product-lightbox') {
            modal.show(event.currentTarget, { time: this.video.currentTime });
            return;
          }
          modal.show(event.currentTarget);
          const media = modal.querySelector(`[data-media-id="${event.currentTarget.dataset.mediaId}"]`);
          if (typeof media?.loadContent === 'function') media.loadContent();
          const expandedVideo = media?.querySelector('video');
          if (expandedVideo) {
            expandedVideo.loop = true;
            expandedVideo.muted = true;
            const resume = () => {
              if (!modal.hasAttribute('open') || !media.classList.contains('active')) return;
              expandedVideo.currentTime = this.video.currentTime;
              expandedVideo.play().catch(() => {});
            };
            if (expandedVideo.readyState >= 1) resume();
            else expandedVideo.addEventListener('loadedmetadata', resume, { once: true, signal: this.abort.signal });
          }
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          this.updatePlayback();
        }, { threshold: [0, 0.5] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.motion.addEventListener('change', () => this.updatePlayback(), options);
        this.setAttribute('data-ready', '');
        sync();
      }

      play() {
        this.video.play().catch(() => {});
      }

      updatePlayback() {
        if (!this.visible || document.hidden || this.motion.matches || document.querySelector('product-modal[open], im-product-lightbox[open]')) {
          this.video.pause();
        } else if (!this.userPaused) {
          this.play();
        }
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["im-sofa360"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('im-sofa360')) {
    class ImSofa360 extends HTMLElement {
      connectedCallback() {
        if (this.ready || this.moving) return;
        this.ready = true;
        this.life = new AbortController();
        const signal = this.life.signal;
        this.selectedCode = null;
        this.variants = JSON.parse(this.querySelector('[data-spin-variants]').textContent);
        this.manifest = JSON.parse(this.querySelector('[data-spin-manifest]').textContent);
        this.panel = this.querySelector('[data-spin-panel]');
        this.canvas = this.querySelector('canvas');
        this.orbitTrack = this.querySelector('[data-spin-orbit-track]');
        this.orbitFill = this.querySelector('[data-spin-orbit-fill]');
        this.orbitDot = this.querySelector('[data-spin-orbit-dot]');
        this.slide = this.closest('[data-spin-slide]');
        this.gallery = this.slide.parentElement;
        this.thumbnail = this.closest('.product__media-wrapper').querySelector('[data-spin-thumbnail]');
        this.thumbnailImage = this.thumbnail?.querySelector('.im-spin-thumbnail-image');
        this.sizes = JSON.parse(this.querySelector('[data-spin-dimensions]').textContent);
        this.frame = 0;
        this.zoom = 1;
        this.generation = 0;

        const bind = (selector, action) => this.querySelector(selector).addEventListener('click', action, { signal });
        bind('[data-spin-dimensions-toggle]', event => {
          const details = this.querySelector('[data-spin-details]');
          details.hidden = !details.hidden;
          event.currentTarget.setAttribute('aria-expanded', String(!details.hidden));
        });
        bind('[data-spin-zoom]', () => { this.zoom = this.zoom === 1 ? 2 : 1; this.draw(); });
        bind('[data-spin-retry]', () => { this.loading = false; this.preload(); this.loadFrame(this.frame); });
        bind('[data-spin-expand]', () => this.expand());
        this.querySelectorAll('[data-spin-position]').forEach(button => button.addEventListener('click', () => {
          this.selectStatus(button.dataset.spinPosition, true);
        }, { signal }));
        this.canvas.addEventListener('pointerdown', event => {
          this.stop(); this.preload();
          this.drag = { x: event.clientX, frame: this.frame };
          this.canvas.setPointerCapture(event.pointerId);
        }, { signal });
        this.canvas.addEventListener('pointermove', event => {
          if (!this.drag) return;
          this.frame = ((this.drag.frame + Math.round((this.drag.x - event.clientX) / 8)) % 36 + 36) % 36;
          this.draw();
        }, { signal });
        for (const name of ['pointerup', 'pointercancel', 'lostpointercapture']) this.canvas.addEventListener(name, () => { this.drag = null; }, { signal });
        this.canvas.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'ArrowLeft') this.move(-1);
          if (event.key === 'ArrowRight') this.move(1);
          if (event.key === 'Home') { this.frame = 0; this.zoom = 1; this.draw(); }
        }, { signal });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.collapse();
          if (event.key === 'Tab' && this.panel.classList.contains('im-spin-expanded')) {
            const controls = [...this.panel.querySelectorAll('button, canvas')].filter(node => node.getClientRects().length);
            const edge = event.shiftKey ? controls[0] : controls[controls.length - 1];
            if (document.activeElement === edge) { event.preventDefault(); (event.shiftKey ? controls[controls.length - 1] : controls[0]).focus(); }
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, { signal });
        const update = () => {
          const picker = document.getElementById(`ProductInfo-${this.dataset.section}`)?.querySelector('variant-radios, variant-selects');
          if (picker && Object.hasOwn(picker, 'currentVariant') && !picker.currentVariant) { this.select(''); return; }
          const input = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="id"]');
          this.select(input?.value || this.dataset.initial);
        };
        this.closest('.shopify-section').addEventListener('change', () => queueMicrotask(update), { signal });
        document.addEventListener('variant:changed', update, { signal });
        window.addEventListener('popstate', update, { signal });
        this.resize = new ResizeObserver(() => this.draw());
        this.resize.observe(this.canvas);
        this.photoResize = new ResizeObserver(entries => {
          const height = entries[0].target.getBoundingClientRect().height;
          if (height > 0) this.style.setProperty('--spin-height', height + 'px');
        });
        const firstPhoto = this.gallery.querySelector('.product__modal-opener');
        if (firstPhoto) this.photoResize.observe(firstPhoto);
        this.intersection = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) this.stop(); });
        this.intersection.observe(this);
        update();
      }
      select(id) {
        const variant = this.variants.find(item => String(item.id) === String(id));
        const code = (variant?.sku || '').split('|')[0].trim();
        this.querySelector('[data-spin-size]').textContent = this.sizes[id] || variant?.option1 || '';
        if (this.selectedCode === code) return;
        this.selectedCode = code;
        this.applySets([]);
        const model = code.match(/^\[([^\]]+)\]:?/);
        if (!model) return;
        const modelId = model[1];
        // HIIS writes the published manifest into the product metafield on every 360 change; no per-visit CDN lookup.
        const data = this.manifest;
        if (!data || data.version !== 1 || data.model_id !== modelId || !Array.isArray(data.sets)) return;
        const key = this.configKey(code, data.feature_aliases, data.ignored_features);
        const sets = data.sets.map(item => this.expandSet(item)).filter(item => item && ['closed', 'opened'].includes(item.status ?? 'closed') &&
          item.model_id === modelId && item.item_color_id === '' &&
          this.configKey(item.config, data.feature_aliases, data.ignored_features) === key && this.validFrames(item.frames, 'spin') &&
          (!item.detail_frames?.length || this.validFrames(item.detail_frames, 'detail')) &&
          Number.isFinite(item.framing) && item.framing >= 0.5 && item.framing <= 1);
        this.applySets(sets);
      }
      expandSet(item) {
        // Metafield sets carry only content hashes ({scope, spin[], detail[]}) to stay under Shopify's 128KB limit; rebuild the CDN URLs here.
        if (!item || typeof item.scope !== 'string' || !Array.isArray(item.spin)) return item;
        const url = (quality, name, index) => `https://attachments.republic.casa/sofa360/${item.scope}/${quality}/${String(index).padStart(2, '0')}_${name}`;
        return { ...item, frames: item.spin.map((name, index) => url('spin', name, index)),
          detail_frames: Array.isArray(item.detail) ? item.detail.map((name, index) => url('detail', name, index)) : [] };
      }
      configKey(code, aliases = {}, ignored = []) {
        if (typeof code !== 'string') return null;
        const match = code.split('|')[0].replace(/[\s,，]/g, '').match(/^\[([^\]]+)\]:?(.*)$/);
        if (!match) return null;
        let body = match[2];
        for (const [short, full] of Object.entries(aliases).sort((a, b) => b[1].length - a[1].length)) {
          if (typeof full === 'string' && full) body = body.split(full).join(short);
        }
        for (const feature of ignored) {
          if (['電頭', '電腰', '電腳', '電貴'].includes(feature)) body = body.split(feature).join('');
        }
        body = body.replace(/\d+\.\d+/g, value => String(Number(value)));
        return `[${match[1]}]:${body}`;
      }
      validFrames(frames, quality) {
        return Array.isArray(frames) && frames.length === 36 && frames.every((url, index) =>
          typeof url === 'string' && new RegExp(`^https://attachments\\.republic\\.casa/sofa360/[a-f0-9]{64}/${quality}/${String(index).padStart(2, '0')}_[a-f0-9]{64}\\.(webp|png|jpg)$`).test(url));
      }
      applySets(sets) {
        this.statusSets = new Map();
        for (const status of ['closed', 'opened']) {
          const set = sets.find(item => (item.status ?? 'closed') === status);
          if (set) this.statusSets.set(status, set);
        }
        this.querySelector('[data-spin-status]').hidden = this.statusSets.size < 2;
        this.selectStatus(this.statusSets.has('closed') ? 'closed' : 'opened');
      }
      selectStatus(status, preserveView = false) {
        const set = this.statusSets.get(status) || null;
        if (preserveView && !set) return;
        this.querySelectorAll('[data-spin-position]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.spinPosition === status));
        });
        this.applySet(set, preserveView);
      }
      applySet(set, preserveView = false) {
        this.hidden = !set;
        this.slide.hidden = !set;
        if (this.thumbnail) this.thumbnail.hidden = !set;
        if (this.thumbnailImage && set && this.thumbnailImage.getAttribute('src') !== set.frames[0]) {
          this.thumbnailImage.removeAttribute('srcset');
          this.thumbnailImage.src = set.frames[0];
        }
        const first = this.gallery.firstElementChild;
        if (first !== this.slide && first.nextElementSibling !== this.slide) {
          this.moving = true;
          first.after(this.slide);
          this.moving = false;
        }
        this.closest('slider-component')?.initPages?.();
        if (this.set === set) return;
        this.stop();
        if (!preserveView) this.collapse();
        this.generation++;
        this.set = set; this.images = []; this.pending = new Map(); this.loading = false; this.drag = null; this.detailImage = null; this.detailKey = '';
        if (!preserveView) this.frame = 0;
        this.zoom = 1;
        this.querySelector('[data-spin-error]').hidden = true;
        this.querySelector('[data-spin-loading]').hidden = true;
        this.querySelector('[data-spin-progress]').style.width = '0';
        this.querySelector('[data-spin-count]').textContent = '0 / 36';
        this.panel.hidden = !set;
        if (!set) return;
        this.loadFrame(this.frame);
        this.draw();
      }
      async loadFrame(index) {
        if (!this.set || this.images[index]) return;
        if (this.pending.has(index)) return this.pending.get(index);
        const generation = this.generation;
        const promise = new Promise(resolve => {
          const image = new Image();
          image.onload = () => {
            if (generation === this.generation) {
              this.images[index] = image;
              const count = this.images.filter(Boolean).length;
              this.querySelector('[data-spin-progress]').style.width = `${count / 36 * 100}%`;
              this.querySelector('[data-spin-count]').textContent = `${count} / 36`;
              if (count === 36) this.querySelector('[data-spin-loading]').hidden = true;
              if (index === this.frame) this.draw();
            }
            resolve();
          };
          image.onerror = () => { if (generation === this.generation) { this.querySelector('[data-spin-error]').hidden = false; this.stop(); } resolve(); };
          image.src = this.set.frames[index];
        });
        this.pending.set(index, promise);
        await promise;
        if (generation === this.generation) this.pending.delete(index);
      }
      async preload() {
        if (this.loading || !this.set) return;
        this.loading = true;
        this.querySelector('[data-spin-error]').hidden = true;
        this.querySelector('[data-spin-loading]').hidden = this.images.filter(Boolean).length === 36;
        let next = 0;
        const generation = this.generation;
        const worker = async () => { while (next < 36 && generation === this.generation) await this.loadFrame(next++); };
        await Promise.all(Array.from({ length: 4 }, worker));
        if (generation === this.generation) this.loading = false;
      }
      move(amount) { this.stop(); this.preload(); this.frame = (this.frame + amount + 36) % 36; this.draw(); }
      stop() {
        clearInterval(this.timer); this.timer = null;

      }
      draw() {
        if (!this.set || this.panel.hidden) return;
        const rect = this.canvas.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = Math.max(1, Math.round(rect.width * ratio));
        this.canvas.height = Math.max(1, Math.round(rect.height * ratio));
        const ctx = this.canvas.getContext('2d');
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        const image = this.zoom > 1 && this.detailImage?.index === this.frame ? this.detailImage.image : this.images[this.frame];
        if (image) {
          const scale = Math.min(this.canvas.width / image.width, this.canvas.height / image.height) * (this.set.framing || 1) * this.zoom;
          ctx.drawImage(image, (this.canvas.width - image.width * scale) / 2, (this.canvas.height - image.height * scale) / 2, image.width * scale, image.height * scale);
        }
        this.canvas.dataset.angle = String(this.frame * 10);
        const orbitProgress = ((18 - this.frame + 36) % 36) / 36;
        const orbitPoint = this.orbitTrack.getPointAtLength(this.orbitTrack.getTotalLength() * orbitProgress);
        this.orbitFill.setAttribute('stroke-dasharray', `${orbitProgress} 1`);
        this.orbitDot.setAttribute('cx', String(orbitPoint.x));
        this.orbitDot.setAttribute('cy', String(orbitPoint.y));
        this.querySelector('[data-spin-zoom]').setAttribute('aria-pressed', String(this.zoom > 1));
        const detail = this.set.detail_frames?.[this.frame];
        if (this.zoom > 1 && detail && this.detailKey !== detail) {
          this.detailKey = detail;
          const generation = this.generation, index = this.frame, high = new Image();
          high.onload = () => { if (generation === this.generation && this.detailKey === detail) { this.detailImage = { index, image: high }; this.draw(); } };
          high.src = detail;
        }
      }
      async expand() {
        if (document.fullscreenElement === this.panel) { await document.exitFullscreen(); return; }
        if (this.panel.classList.contains('im-spin-expanded')) { this.collapse(); return; }
        if (this.panel.requestFullscreen) {
          try { await this.panel.requestFullscreen(); return; } catch (_) {}
        }
        this.panel.classList.add('im-spin-expanded');
        this.oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.canvas.focus();
      }
      collapse() {
        if (document.fullscreenElement === this.panel) document.exitFullscreen().catch(() => {});
        if (this.panel.classList.contains('im-spin-expanded')) {
          this.panel.classList.remove('im-spin-expanded');
          document.body.style.overflow = this.oldOverflow || '';
          this.querySelector('[data-spin-expand]').focus();
        }
      }
      disconnectedCallback() {
        if (this.moving) return;
        this.stop(); this.collapse(); this.generation++;
        this.life.abort(); this.resize.disconnect(); this.photoResize.disconnect(); this.intersection.disconnect(); this.ready = false;
      }
    }
    customElements.define('im-sofa360', ImSofa360);
  }
  } catch(e) { console.error(e); }
})();

})();
